import React, {  useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { baseUrl } from "..";


import { useUser } from "../Context/userContext";
import { Spinner } from "reactstrap";



function useIsLaptop() {
  const [isLaptop, setIsLaptop] = useState(
    window.matchMedia("(min-width: 768px)").matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 768px)");

    const handleChange = (e) => {
      setIsLaptop(e.matches);
    };

    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  return isLaptop;
}


    const columns =[
  {
    field: "weekStartDate",
    headerName: "Payment Deduction Week Start Date",
    width: 140,
  },
  {
    field: "hostelId",
    headerName: "Hostel ID",
    width: 120,
  },
  {
    field: "bookingId",
    headerName: "Booking ID",
    width: 180,
  },
  {
    field: "bookingDate",
    headerName: "Booking Date",
    width: 140,
  },
  {
    field: "hostelRevenue",
    headerName: "Hostel Revenue - Pre-Cancellation",
    width: 150,
  },
  {
    field: "cancelledAmount",
    headerName: "Cancelled Amount",
    width: 170,
  },
  {
    field: "otherComments",
    headerName: "Other Comments",
    width: 250,
  },
]



const Deductions = () => {





const { selectedHostelId } = useUser();

const hostelId =
  selectedHostelId ||
  localStorage.getItem("selectedHostel") ||
  "";

  const [allDeductions ,setAllDeductions] = useState([])

    const [loading,setLoading] = useState(false)
  const isLaptop = useIsLaptop();
const isMobile = !isLaptop;
let pageSize = 10

const convertDeductionsIntoTableFormat = (deductions = []) =>
  deductions.map((item) => ({
    id: item.id,
    weekStartDate: item.week_start_date,
    bookingId: item.booking_id,
    hostelId: item.hostel_id,
    bookingDate: item.booking_date,
    hostelRevenue: item.hostel_revenue,
    cancelledAmount: item.cancelled_amount,
    otherComments: item.other_comments,
  }));

useEffect(()=>{
const fetchDeductions =async()=>{
try {
    
    if(!hostelId) return console.error("hostelid not selected")
      setLoading(true)
    const headers = {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          };
    
          const res = await axios.get(
            `${baseUrl}/deductions/${selectedHostelId}`,
            headers
          );
          if (res.status === 200) {
            let r = convertDeductionsIntoTableFormat(res.data.deductions)
            setAllDeductions(r)
          }
          
} catch (error) {
      console.log("error in getting invoice address", error);
}finally{
  setLoading(false)
}
}
fetchDeductions()

},[hostelId])

  return (
    <div className={`${isLaptop ? "m-5" : "mt-2"}`}>
           {!loading && (
                  <>
                    <div className="d-flex justify-content-between mb-3">
                    </div>
                    <DataGrid
            sx={{
            '& .MuiDataGrid-columnHeader': {
              padding: '10px 8px',
              alignItems: 'center',
            },
            '& .MuiDataGrid-columnHeaderTitle': {
              whiteSpace: 'normal',
              lineHeight: '1.3',
              textAlign: 'center',
              fontSize: '13px',
            },
          }}
          columnHeaderHeight={90}
                      rows={allDeductions}
                      columns={columns}
                      pageSize={pageSize}
                      rowsPerPageOptions={[1, 2, 4]}
                      pagination
                      autoHeight
                      onPageChange={(params) =>
                        this.setState({ currentPage: params.page })
                      }
                      onPageSizeChange={(params) =>
                        this.setState({ pageSize: params.pageSize })
                      }
                      getRowId={(row) => row.id}
                    />
                  </>
                )}
      
       {loading &&
               <div style={{textAlign:"center",marginTop:"6rem"}}> 
                 <Spinner />
               </div>
              }
    </div>
  )
}

export default Deductions
